/* eslint-disable max-len */
import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { PulseLoader } from 'react-spinners';
import { FaExclamationCircle } from 'react-icons/fa';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
} from 'react-tabs';
import { uploadMaterialImage, categories as categoriesPortal } from '../../../../queries';

import Information from './Information';
import Specification from './Specification';
import Stock from './Stock';
import Promotion from './Promotion';

import { Content, Footer } from './styles';

class RecoveryModal extends Component {
  state = {
    deleteLoading: false,
    loading: false,
    tabIndex: 0,
    originalPrice: 0,
    currentCategory: null,
    informationError: false,
    specificationError: false,
    stockError: false,
    promotionError: false,
    imageError: false,
  }

  handleSubmit = async () => {
    const data = await this.validateInputs();

    const {
      informationError,
      specificationError,
      stockError,
      promotionError,
    } = this.state;

    if (!informationError && !specificationError && !stockError && !promotionError) {
      this.setState({ loading: true });

      if (data.specialPrice === null) delete data.specialPrice;
      if (data.description === null) delete data.description;
      if (data.file !== null) {
        try {
          const res = await this.props.uploadMaterialImage({
            variables: {
              storeId: this.props.storeId,
              image: data.file,
            },
          });

          data.imageUrl = res.data.uploadMaterialImagePortal;
        } catch (err) {
          this.setState({ loading: false });

          if (/Invalid file type/i.test(err.message)) this.setState({ imageError: true });
        }
      }

      delete data.file;

      if (!this.state.currentMaterial) {
        this.props
          .addNewMaterial({
            variables: {
              storeId: this.props.storeId,
              data,
            },
            refetchQueries: [{ query: categoriesPortal, variables: { storeId: this.props.storeId } }],
          })
          .then(async () => {
            this.setState({ loading: false });
            this.props.alert.success('Material adicionado com sucesso');
            this.props.close();
          });
      } else {
        this.props
          .editMaterial({
            variables: {
              storeId: this.props.storeId,
              materialId: this.state.currentMaterial.id,
              data,
            },
            refetchQueries: [{ query: categoriesPortal, variables: { storeId: this.props.storeId } }],
          })
          .then(async () => {
            this.setState({ loading: false });
            this.props.alert.success('Material editado com sucesso');
            this.props.close();
          });
      }
    }
  }

  deleteMaterial = () => {
    this.setState({ deleteLoading: true });

    this.props
      .deleteMaterial({
        variables: {
          storeId: this.props.storeId,
          materialId: this.state.currentMaterial.id,
        },
        refetchQueries: [{ query: categoriesPortal, variables: { storeId: this.props.storeId } }],
      })
      .then(async () => {
        this.setState({ deleteLoading: false });
        this.props.alert.success('Material excluído com sucesso');
        this.props.close();
      });
  }

  validateInputs = async () => {
    this.setState({
      informationError: false,
      specificationError: false,
      stockError: false,
      promotionError: false,
      imageError: false,
    });

    const information = await this.informationContent.handleSubmit();
    const specification = await this.specificationContent.handleSubmit();
    const stock = await this.stockContent.handleSubmit();
    const promotion = await this.promotionContent.handleSubmit();

    if (!information) this.setState({ informationError: true });
    if (specification.specification && specification.error) this.setState({ specificationError: true });
    if (!stock) this.setState({ stockError: true });
    if (promotion.promotion && promotion.error) this.setState({ promotionError: true });

    return {
      ...information,
      description: !specification.specification ? null : specification.description,
      ...stock,
      specialPrice: !promotion.promotion ? null : promotion.specialPrice,
    };
  }

  handleOriginalPrice = (price) => {
    this.setState({ originalPrice: price });
  }

  openAddMaterialModal = (id, category) => {
    this.setState({
      title: 'Adicionar material',
      tabIndex: 0,
      originalPrice: 0,
      currentCategory: id && category ? { value: id, label: category } : null,
      currentMaterial: null,
      informationError: false,
      specificationError: false,
      stockError: false,
      promotionError: false,
    });
  }

  openEditMaterialModal = (item) => {
    const { categories } = this.props;

    const currentCategory = categories.find(category => category.value === item.categoryId);

    this.setState({
      title: 'Editar material',
      tabIndex: 0,
      originalPrice: item.price,
      currentCategory,
      currentMaterial: item,
      informationError: false,
      specificationError: false,
      stockError: false,
      promotionError: false,
    });
  }

  render() {
    const {
      deleteLoading,
      loading,
      title,
      tabIndex,
      originalPrice,
      informationError,
      imageError,
      specificationError,
      stockError,
      promotionError,
    } = this.state;

    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        closeOnEsc={false}
        closeOnOverlayClick={false}
        styles={{
          modal: { width: '900px' },
        }}
      >
        <Content>
          <h2>{title}</h2>
          <Tabs
            selectedIndex={tabIndex}
            onSelect={index => this.setState({ tabIndex: index })}
            forceRenderTabPanel
          >
            <div className="tabs">
              <TabList>
                <Tab>
                  <span>Informações gerais</span>
                  {(informationError || imageError) && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                </Tab>
                <Tab>
                  <span>Especificações</span>
                  {specificationError && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                </Tab>
                <Tab>
                  <span>Estoque</span>
                  {stockError && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                </Tab>
                <Tab>
                  <span>Promoção</span>
                  {promotionError && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                </Tab>
              </TabList>
            </div>
            <div className="content">
              <TabPanel>
                <Information
                  ref={(ref) => { this.informationContent = ref; }}
                  active={tabIndex === 0}
                  handleOriginalPrice={this.handleOriginalPrice}
                  categories={this.props.categories}
                  currentCategory={this.state.currentCategory}
                  currentMaterial={this.state.currentMaterial}
                  imageError={this.state.imageError}
                />
              </TabPanel>
              <TabPanel>
                <Specification
                  ref={(ref) => { this.specificationContent = ref; }}
                  active={tabIndex === 1}
                  currentMaterial={this.state.currentMaterial}
                />
              </TabPanel>
              <TabPanel>
                <Stock
                  ref={(ref) => { this.stockContent = ref; }}
                  active={tabIndex === 2}
                  currentMaterial={this.state.currentMaterial}
                />
              </TabPanel>
              <TabPanel>
                <Promotion
                  ref={(ref) => { this.promotionContent = ref; }}
                  active={tabIndex === 3}
                  originalPrice={originalPrice}
                  currentMaterial={this.state.currentMaterial}
                />
              </TabPanel>
            </div>
          </Tabs>
          <Footer delete={!!this.state.currentMaterial}>
            <button
              type="submit"
              className="btn-submit"
              onClick={this.state.currentMaterial ? this.deleteMaterial : close}
            >
              {!this.state.currentMaterial && !deleteLoading && 'Cancelar'}
              {this.state.currentMaterial && !deleteLoading && 'Excluir'}
              {deleteLoading && (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#e50000"
                  deleteLoading={deleteLoading}
                />
              )}
            </button>
            <button type="submit" className="btn-submit" disabled={loading} onClick={this.handleSubmit}>
              {!loading ? (
                <div>
                  <span>Salvar</span>
                </div>
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#FFFFFF"
                  loading={loading}
                />
              )}
            </button>
          </Footer>
        </Content>
      </Modal>
    );
  }
}

export default compose(
  withAlert(),
  graphql(uploadMaterialImage, { name: 'uploadMaterialImage', withRef: true }),
)(RecoveryModal);
